import { useQuery } from '@tanstack/react-query';
import { useUpdateEffect } from 'react-use';

import { useLocale } from 'next-intl';

import { useVerification } from '@/contexts/VerificationContext/useVerification';

import { UserApi } from '@/api/domains/user-api';
import { UserSubscription } from '@/api/types/user.types';

import { ProfileQueryKeys } from '@/contexts/QueryContext/query.keys';

export const useUsersSubscriptions = () => {
  const locale = useLocale();

  const { isInitialCheckDone, userAccessToken } = useVerification();

  const { data, isLoading, status, refetch } = useQuery({
    queryKey: ProfileQueryKeys.usersSubscription(locale),
    queryFn: () => UserApi.fetchUsersSubscriptions({ locale }),
    staleTime: 0,
    select: (data: UserSubscription[]) => UserApi.transformMySubscriptionsData(data),
    enabled: isInitialCheckDone,
  });

  useUpdateEffect(() => {
    refetch();
  }, [userAccessToken]);

  const subscriptions = data || {
    mySubscriptions: [],
    mainSubscriptions: [],
    subscriptions: [],
    list: [],
  };

  return { subscriptions, isLoading, status, refetch };
};
